import React, { useCallback, useRef, useEffect } from "react";
import { useCentralStore } from "../../../../store/Central";
import { Loader2 } from "lucide-react";
import { RegionConfig } from "../../../../types/region.types";
import { CountriesSection } from "./components/CountriesSection";
import { shallow } from "zustand/shallow";

export const RegionenAdminPage: React.FC = () => {
	const regionsLoading = useCentralStore(state => state.regionsLoading);
	const priceListRegionsLoading = useCentralStore(state => state.priceListRegionsLoading);
	const updateRegionAndSave = useCentralStore(state => state.updateRegionAndSave);

	const debounceTimers = useRef<{ [key: string]: NodeJS.Timeout }>({});

	const handleUpdateField = useCallback((index: number, field: keyof RegionConfig, value: any) => {
		// Clear existing timer for this field
		const timerKey = `${index}-${field}`;
		if (debounceTimers.current[timerKey]) {
			clearTimeout(debounceTimers.current[timerKey]);
		}

		// For boolean fields (Switch), save immediately
		if (field === 'is_mwst_eust') {
			updateRegionAndSave(index, field, value);
			return;
		}

		// For text/number fields, debounce
		debounceTimers.current[timerKey] = setTimeout(() => {
			updateRegionAndSave(index, field, value);
			delete debounceTimers.current[timerKey];
		}, 500);
	}, [updateRegionAndSave]);

	// Cleanup timers on unmount
	useEffect(() => {
		return () => {
			Object.values(debounceTimers.current).forEach(timer => clearTimeout(timer));
		};
	}, []);

	if (regionsLoading || priceListRegionsLoading) {
		return (
			<div className="p-6">
				<div className="max-w-4xl">
					<h1 className="text-2xl font-semibold text-gray-900 mb-6">
						Regionen
					</h1>
					<div className="flex items-center justify-center py-12">
						<Loader2 className="h-8 w-8 animate-spin text-gray-500" />
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="p-6">
			<div className="max-w-4xl">
				<h1 className="text-2xl font-semibold text-gray-900 mb-6">Regionen</h1>
				<CountriesSection handleUpdateField={handleUpdateField} />
			</div>
		</div>
	);
};